module.exports = __webpack_public_path__ + "img/profile.f728de27.svg";